import React from 'react'
import ConfettiExplosion from '@reonomy/react-confetti-explosion'
import styles from './confetti.module.css'

export const Confetti = React.memo(() => {
  return (
    <div className={styles.confetti}>
      <ConfettiExplosion
        force={0.5}
        duration={3000}
        particleCount={40}
        floorHeight={1000}
        floorWidth={1000}
        colors={[
          '#d9a62b', // yellow
          '#FF0000', // red
          '#281A36', // purple
          '#00CDA8', // green
        ]}
      />
    </div>
  )
})
